import React from "react";
import SectionTwoImageMobile from "../../Assets/Images/about-us-section-two-mobile-1.png";
import ProtectionIcon from "../../Assets/Images/protection-icon.svg";
import ProtectionImage from "../../Assets/Images/protection-image.jpg";
import ProtectionImageBigScreen from "../../Assets/Images/protection-image-big-screen.png";
import { useTranslation } from "../../Hooks/useTranslation"; // Import the hook

const Protection = ({ isScrollable }) => {
  const translations = useTranslation(); // Get translations dynamically
  return (
    <>
      <div
        className="flex flex-col lg:mt-[5rem] mt-[1.5rem] lg:pt-[320px]"
      >
        <div className="Screenmax1920-content">
          <div className="circle-div animate__animated animate__fadeInRight lg:hidden block -mr-[1rem] mb-4">
            <img
              src={ProtectionImage}
              width={"100%"}
              className="object-cover"
              alt="not found"
            />
          </div>
          <div className="mt-2 lg:mt-2 md:mt-[3rem] mb-4 animate__animated animate__fadeIn max-w-[400px] flex items-start lg:block container">
            <img src={ProtectionIcon} className="mb-4 mr-4 lg:mr-0" alt="" />
            <div className="universal-benefits-content">
              <h3 className="text-[14px] lg:text-[18px] font-semibold mb-2 lg:leading-[22px] leading-[20px]">
                {translations.universeProtection_title}
              </h3>
              <p
                className="text-[14px] mb-3 font-mobile-14 leading-[24px]"
                dangerouslySetInnerHTML={{
                  __html: translations.universeProtection_desc,
                }}
              ></p>
            </div>
          </div>
          <div className="tab-capsule-img-box relative lg:absolute w-[100%] lg:w-[50%] pl-[20px] right-0 top-12 lg:block hidden">
            <div className="tab-capsule-inner-box flex-1 w-[100%] flex-none !ml-auto ms-[5%] mt-[5%] md:mt-0 order-first lg:order-last">
              <div className="px-4 lg:px-[0] pb-[5%] block lg:hidden animate__animated animate__fadeInLeft">
                <div className="text-[16px] lg:text-[18px] font-normal">
                  Select Term
                </div>
                <div className="text-[24px] lg:text-[40px]">
                  <span className="font-semibold">Main benefits</span> of the
                  policy
                </div>
              </div>
              <div className="circle-div lg:ml-0 mb-[0] md:mb-0 max-h-[688px] animate__animated animate__fadeInRight">
                <img
                  src={ProtectionImage}
                  width={"100%"}
                  className="object-cover"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="bigScreen-content container">
          <div className="flex items-center h-[100%] justify-between">
            <div className="mt-[300px] universal-benefits-wrapper mb-4 animate__animated animate__fadeIn max-w-[400px] flex items-start lg:block ">
              <img src={ProtectionIcon} className="mb-4 mr-4 lg:mr-0" alt="" />
              <div className="universal-benefits-content">
                <h3 className="text-[14px] lg:text-[18px] font-semibold mb-2 lg:leading-[22px] leading-[20px]">
                  {translations.universeProtection_title}
                </h3>
                <p
                  className="text-[14px] mb-3 leading-[24px]"
                  dangerouslySetInnerHTML={{
                    __html: translations.universeProtection_desc,
                  }}
                ></p>
              </div>
            </div>
            <div className="tab-capsule-img-box relative lg:absolute w-[100%] lg:w-[50%] pl-[20px] right-0 top-12 lg:block hidden">
              <div className="tab-capsule-inner-box flex-1 w-[100%] flex-none !ml-auto ms-[5%] mt-[5%] md:mt-0 order-first lg:order-last">
                <div className="px-4 lg:px-[0] pb-[5%] block lg:hidden animate__animated animate__fadeInLeft">
                  <div className="text-[16px] lg:text-[18px] font-normal">
                    Select Term
                  </div>
                  <div className="text-[24px] lg:text-[40px]">
                    <span className="font-semibold">Main benefits</span> of the
                    policy
                  </div>
                </div>
                <div className="circle-div lg:ml-0 mb-[0] md:mb-0 max-h-[688px] animate__animated animate__fadeInRight">
                  <img
                    src={ProtectionImage}
                    width={"100%"}
                    className="object-cover protection-image"
                  />
                  <img
                    src={ProtectionImageBigScreen}
                    width={"100%"}
                    className="object-cover protection-image-big-screen d-none"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Protection;
